<script>
	export let show = false;
  export let images = [];

	let currSlide = 0;

	let interval;

	const mousePos = {
		x: 0,
	};

	function getMousePos(e) {
		mousePos.x = e.touches[0].clientX;
	}

	function checkSwipe(e) {
		const swipeDist = mousePos.x - e.changedTouches[0].clientX;

		if (!(Math.abs(swipeDist) > 100)) return;

		if (swipeDist > 0) {
			return changeSlide('next');
		}

		return changeSlide('prev');
	}

	function startSlider() {
		interval = setInterval(() => {
			changeSlide('next', 'auto');
		}, 3000);
	}

	function changeSlide(direction, calledFrom) {
		const id = this ? this.id : direction;

		// If the function is not called from an auto slider function then reset the interval
		if (!calledFrom) {
			clearInterval(interval);
			startSlider();
		}

		if (currSlide === 0 && id === 'prev') currSlide = images.length - 1;
		else if (currSlide === images.length - 1 && id === 'next') currSlide = 0;

		if (id === 'prev') {
			currSlide = Math.max(0, currSlide - 1);
		} else {
			currSlide = Math.min(images.length - 1, currSlide + 1);
		}
	}

	function closeGallery() {
		show = false;
		document.body.style.overflow = 'auto';
	}

	$: if(!show) {
		clearInterval(interval);
	}
</script>

{#if show}
	{(document.body.style.overflow = 'hidden')}
	{startSlider()}
	<div class="gallery" on:touchstart={getMousePos} on:touchend={checkSwipe}>
		<span class="gallery__close" on:click={closeGallery}>
			<img src="img/icons/cross.svg" alt="" />
		</span>
		<div class="gallery__container">
			<span class="gallery__arrow" id="prev" on:click={changeSlide}>
				<img src="img/left.svg" alt="" />
			</span>
			<img class="gallery__image" src="{images[currSlide].jpg.w512}" alt="" />
			<span class="gallery__arrow" id="next" on:click={changeSlide}>
				<img src="img/right.svg" alt="" />
			</span>
			<span class="gallery__mobile-info">Swipe to view images</span>
		</div>
	</div>
{/if}

<style>
	.gallery {
		position: fixed;
		z-index: 1200;
		user-select: none;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.6);
		padding: 5rem;
		backdrop-filter: blur(10px);
	}

	.gallery__close {
		position: absolute;
		top: 5rem;
		right: 5rem;
		cursor: pointer;
	}

	.gallery__close img {
		width: 5rem;
	}

	.gallery__container {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.gallery__arrow {
		font-size: 5rem;
		cursor: pointer;
	}

	.gallery__mobile-info {
		display: none;
	}

	.gallery__container img {
		height: 90%;
	}
	@media screen and (max-width: 1500px) {
		.gallery__container img {
			width: 70%;
			object-fit: contain;
		}
	}
	@media screen and (min-width: 700px) and (max-width: 900px) {
		.gallery__container img {
			width: 80%;
			object-fit: contain;
		}
	}
	@media screen and (max-width: 700px) {
		.gallery__close {
			top: 2rem;
			right: 2rem;
		}

		.gallery {
			padding: 2rem;
		}

		.gallery__container {
			flex-direction: column;
			justify-content: center;
		}

		.gallery__arrow {
			display: none;
		}

		.gallery__container img {
			width: 100%;
			object-fit: contain;
		}

		.gallery__mobile-info {
			margin-top: 5rem;
			display: block;
		}
	}
</style>
